import ICONS from '@/shared/entities/constants/icons';
import React from 'react';
import { Icon } from 'vkit/lib/components';
import style from '@/modules/customization/components/bannerPreview/text/styles/bannerTextPreview.module.scss';

export interface BannerTextPreviewProps {
  width?: number;
  height?: number;
  description?: string;
  buttonLabel?: string;
  buttonLink?: string;
}

export const BannerTextPreview: React.FC<BannerTextPreviewProps> = ({
  width = 277,
  height = 160,
  description,
  buttonLabel,
  buttonLink,
}) => {
  return (
    <div
      data-testid='banner_text_preview'
      style={{
        width,
        height,
      }}
      className={style.bannerTextPreview}>
      <p className={style.description}>{description}</p>
      {buttonLabel && (
        <a
          href={buttonLink || undefined}
          className={style.button}
          target='_blank'
          rel='noopener noreferrer'>
          {buttonLabel}
          <Icon name={ICONS.LINK} color='clear' />
        </a>
      )}
    </div>
  );
};
